function getActiveClasses() {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return [].concat.apply([], classes).reduce(function (result, option) {
        var nextClasses = typeof option === "object" ? joinClasses(option) : option;
        return "" + result + (result ? " " : "") + nextClasses;
    }, "");
}
function joinClasses(classes) {
    return Object.keys(classes)
        .filter(function (key) { return classes[key]; })
        .join(" ");
}

export { getActiveClasses };
//# sourceMappingURL=get-active-classes.es.js.map
